import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Llevaba años en terapia intentando entender por qué saboteaba todas mis relaciones cuando se volvían serias. Al hacer los ejercicios, descubrí que estaba repitiendo la historia de abandono de mi abuela. Liberar eso fue como quitarme una roca del pecho. Hoy estoy comprometida y en paz.',
    author: 'María S.',
    age: 34
  }, {
    text: 'Siempre sentí una culpa inmensa al ganar dinero. Sentía que no lo merecía. Este programa me hizo ver la lealtad inconsciente a la escasez de mis padres. El módulo de liberación emocional me hizo llorar como nunca, pero me liberó. Mi negocio ha crecido un 40% desde entonces.',
    author: 'Laura M.',
    age: 41
  }, {
    text: "Pensé que mi ansiedad era 'así soy yo'. Entender que estaba cargando el miedo no procesado de mi linaje materno lo cambió todo. Por primera vez en mi vida, siento que respiro profundo. Es un viaje intenso, pero el más hermoso que he hecho.",
    author: 'Elena R.',
    age: 29
  }];
  return <section className="py-24 bg-beige relative" data-id="element-222">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-223">
        <FadeIn className="text-center mb-16" data-id="element-224">
          <h2 className="font-heading text-4xl text-charcoal mb-4" data-id="element-225">
            Historias de Liberación
          </h2>
          <div className="w-16 h-[1px] bg-sage mx-auto" data-id="element-226" />
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-227">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.2} direction="up" data-id="element-228">
              <div className="bg-white p-8 rounded-sm shadow-sm border border-beige-dark relative h-full flex flex-col" data-id="element-229">
                <span className="text-gold font-heading text-6xl absolute top-4 left-6 opacity-20" data-id="element-230">
                  "
                </span>
                <p className="font-body text-charcoal/80 leading-relaxed italic mb-8 relative z-10 flex-grow" data-id="element-231">
                  {testimonial.text}
                </p>
                <div className="mt-auto border-t border-beige-dark pt-4" data-id="element-232">
                  <p className="font-heading text-charcoal font-semibold" data-id="element-233">
                    {testimonial.author}
                  </p>
                  <p className="font-body text-sm text-charcoal/50" data-id="element-234">
                    {testimonial.age} años
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}